
window.addEventListener('frame-ready', init)

function init() {

    const ITEMS = Array.from(document.querySelectorAll('.product-card, .link-card'))

    if (ITEMS.length <= 0) return

    ITEMS.forEach(trackMouseInCard)

    function trackMouseInCard(item) {
        let { height, width } = item.getBoundingClientRect()

        item.addEventListener('mouseout', e => {
            item.style =   `opacity: 1; transform: perspective(190px) rotateX(0) rotateY(0);`
        })

        item.addEventListener('mousemove', e => {
            // Tracking x y relative to card

            let { offsetTop, offsetLeft } = item

            // y is mouse position in window
            let { y, x } = e

            let y_in_card = (window.scrollY - offsetTop + y)
            let x_in_card = (window.scrollX - offsetLeft + x)

            let rotate = 1.2
            // how far is mouse from center of card

            let style =  `opacity: 1; transform: perspective(190px)`

            if(y_in_card > height / 2) {
                style = `${style} rotateX(-${rotate}deg)`
            } else {
                style = `${style} rotateX(${rotate}deg)`
            }

            if(x_in_card > width / 2) {
                style = `${style} rotateY(${rotate}deg);`
            } else {
                style = `${style} rotateY(-${rotate}deg);`
            }

            item.style = style
        })
    }

}
